import PageHeader from '@/components/PageHeader';
import { styled } from 'styled-components';
import ComplainceTable from './components/BillsTable';
import withAuthentication from '@/hooks/withAuthentication';
import BillsTable from './components/BillsTable';
import { usePermissions } from '@/hooks/usePermissions';
import { EmptyState } from '@/components/EmptyState';
import BillsMetrics from './components/BillsMetrics';

function Bills() {
  const { role, hasPermission, superAdmin } = usePermissions();
  const canReadBills = hasPermission('bills', 'read');
  const isASuperAdmin = superAdmin(true);
  const isRoleAdmin = role('Admin');

  return (
    <>
      <PageHeader title="Bills" subtitle="View and manage all Bills" />
      <BillsView>
        {canReadBills || isASuperAdmin || isRoleAdmin ? (
          <div>
            <BillsMetrics />
            <BillsTable />
          </div>
        ) : (
          <EmptyState />
        )}
      </BillsView>
    </>
  );
}

export default withAuthentication(Bills);

const BillsView = styled.div`
  width: 82%;
  padding: 30px;
  background-color: ${({ theme }) => theme.colors.white};
  overflow-y: scroll;
  height: 100%;
  padding-top: 120px;
  overflow-x: hidden;
  margin-left: 18%;
`;
